export enum CmpConfigPublisherRestrictionType {
    NOT_ALLOWED = 0,
    REQUIRE_CONSENT = 1,
    REQUIRE_LEGITIMATE_INTEREST = 2
}
